import React from "react";
import EVChargingSessionReportBreadCrumbs from "../../Components/EVChargingSessionReport/EVChargingSessionReportBreadCrumbs";
import EVChargingSessionReport from "../../Components/EVChargingSessionReport/EVChargingSessionReport";

export default function EVChargingSessionReportListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <EVChargingSessionReportBreadCrumbs />
        <EVChargingSessionReport />
      </div>
    </React.Fragment>
  );
}
